import { useState } from 'react';
import { Box, Button, Menu } from '@mui/material';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { DateRange } from 'react-date-range';
import { de } from 'date-fns/locale';

const ContractTimeFrameSelector = ({
  formState,
  setFormState,
  tempRange,
  setTempRange,
  theme,
}) => {
  const [timeframeSelectorAnchor, setTimeframeSelectorAnchor] = useState(null);

  return (
    <Box sx={{ mt: 2, height: 40 }}>
      <Button
        variant="outlined"
        disableElevation
        onClick={(evt) => setTimeframeSelectorAnchor(evt.currentTarget)}
        endIcon={<KeyboardArrowDown />}
        sx={{ width: '100%', height: 40 }}
      >
        {formState.startDate
          ? new Date(formState.startDate).toLocaleDateString('de-DE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : 'Startdatum auswählen'}{' '}
        -{' '}
        {formState.endDate
          ? new Date(formState.endDate).toLocaleDateString('de-DE', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : 'Enddatum auswählen'}
      </Button>
      <Menu
        key={'timeframe'}
        anchorEl={timeframeSelectorAnchor}
        open={!!timeframeSelectorAnchor}
        onClose={() => setTimeframeSelectorAnchor(null)}
        onClick={(evt) => evt.stopPropagation()}
        sx={{ minWidth: '200px', minHeight: '200px' }}
      >
        <DateRange
          locale={de}
          ranges={[tempRange]}
          onChange={(item) => {
            const selection = item.selection;
            setTempRange({
              ...selection,
              key: 'selection',
            });
          }}
          showDateDisplay={false}
          rangeColors={[theme.palette.primary.main]}
        />
        <Box sx={{ textAlign: 'center', mt: 1 }}>
          <Button
            variant="contained"
            sx={{ mx: 2, width: '90%' }}
            onClick={() => {
              const newStart = new Date(tempRange.startDate);
              newStart.setHours(0, 0, 0, 0);
              const newEnd = new Date(tempRange.endDate);
              newEnd.setHours(23, 59, 59, 999);
              setFormState({
                ...formState,
                startDate: newStart,
                endDate: newEnd,
              });
              setTimeframeSelectorAnchor(null);
            }}
          >
            Anwenden
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default ContractTimeFrameSelector;
